import { render } from "./BirthSideNav.vue?vue&type=template&id=63687be4"
import script from "./BirthSideNav.vue?vue&type=script&lang=js"
export * from "./BirthSideNav.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__